// src/App.js
import React, { useState, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import routes from "./Routes";
import LoadingSpinner from "./components/LoadingSpinner/LoadingSpinner";
import PopUp from "./components/PopUp/PopUp";
import Goftino from "./components/Goftino/Goftino";


function App() {
  const [loading, setLoading] = useState(true);
  const router = useRoutes(routes);
  useEffect(() => {
    // Simulate a loading delay for demo purposes
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="App rtl">
      <div>{router}</div>
      <PopUp />
      <Goftino/>
    </div>
  );
}

export default App;
